function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6638_14733)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 3a1 1 0 01.293-.707C2.435 2.15 2.6 2 3 2h14.172a1 1 0 01.706.293l3.83 3.829a1 1 0 01.292.706V10a1 1 0 102 0V6.828c0-.795-.316-1.558-.878-2.12l-3.83-3.83A3 3 0 0017.172 0H3a3 3 0 00-3 3v22a3 3 0 003 3h7a1 1 0 100-2H3a1 1 0 01-1-1V3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 8a1 1 0 100 2h10.667a1 1 0 100-2H6zM6 14a1 1 0 100 2h4a1 1 0 100-2H6zM5 21a1 1 0 011-1h4a1 1 0 110 2H6a1 1 0 01-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.019 21a8 8 0 1114.319 4.906l4.37 4.388a1 1 0 01-1.416 1.412l-4.368-4.386A8 8 0 0113.019 21zm8-6a6 6 0 100 12 6 6 0 000-12z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6638_14733"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h32v32H0z"
})))));